import React from "react";
import { useLang } from "../context/LanguageContext";
import { OFFICES } from "../mock/mock";

// variant: "light" (cream bg) | "dark" (footer)
export const OfficeCards = ({ variant = "light" }) => {
  const { tr } = useLang();
  const dark = variant === "dark";

  const s = dark
    ? { card: "bg-white/[0.03]", border: "border-white/10", hqBorder: "border-[#a67c52]/80", region: "text-white", link: "text-[#b5ab9b] hover:text-white", ring: "ring-white/25" }
    : { card: "bg-white", border: "border-[#e5dccb]", hqBorder: "border-[#a67c52]", region: "text-[#211d18]", link: "text-[#6a6254] hover:text-[#a67c52]", ring: "ring-black/10" };

  const Card = ({ o }) => (
    <div
      data-testid={`office-${o.code}`}
      className={`${s.card} border ${o.hq ? `${s.hqBorder} border-2` : s.border} px-3 py-2.5 transition-colors`}
    >
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <img src={`/flags/${o.code}.png`} alt="" className={`w-5 h-[14px] object-cover rounded-[2px] ring-1 ${s.ring} shrink-0`} />
        <p className={`text-[12px] font-medium leading-tight ${s.region}`}>{o.region}</p>
        {o.hq && (
          <span className="text-[8.5px] uppercase tracking-[0.14em] bg-[#a67c52] text-white px-1.5 py-[1px] leading-none">
            {tr({ en: "HQ", tr: "Merkez" })}
          </span>
        )}
      </div>
      <a href={`tel:${o.phoneTel}`} className={`block text-[11.5px] leading-relaxed ${s.link} transition-colors`}>{o.phone}</a>
      <a href={`mailto:${o.email}`} className={`block text-[11.5px] leading-relaxed ${s.link} transition-colors break-all`}>{o.email}</a>
    </div>
  );

  const hq = OFFICES.find((o) => o.hq);
  const rest = OFFICES.filter((o) => !o.hq);

  return (
    <div className="space-y-2" data-testid="office-cards">
      {hq && <Card o={hq} />}
      <div className="grid grid-cols-2 gap-2">
        {rest.map((o) => (
          <Card key={o.code} o={o} />
        ))}
      </div>
    </div>
  );
};

export default OfficeCards;
